module.exports = __webpack_public_path__ + "img/icon_logout_white.64ca637e.svg";